
/**
 * Created by nijin on 21/12/16.
 */
import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import {AuthService} from "../auth/auth.service";
import {UtilService} from "./util.service";
import {environment} from "../../environments/environment";


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) { }

  canLoad(route: Route) {
    if (this.authService.isLoggedIn() && route.path !=='register') {
      return true;
    }
    if (!this.authService.isLoggedIn() && route.path ==='register') {
      return true;
    }
    if (!this.authService.isLoggedIn()){
      this.router.navigate(['/']);
      return true;
    }
    if (this.authService.isLoggedIn() && route.path === 'register') {
      this.router.navigate(['/things']);
      return false;
    }
    if (!this.authService.isLoggedIn() && route.path === 'register') {
      return true;
    }
    let url = `/${route.path}`;
    this.router.navigate(['/register'], { queryParams: { redirectTo: url } });
    return this.authService.isLoggedIn();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (next.fragment) {
      const response = this.authService.setTokenFromUrl(next.fragment);
     // this.authService.setToken(response.accessToken, response.idToken);
      this.authService.setLogoutUrl(environment.auth.site, environment.auth.endSession,
        environment.auth.logoutUri);
      next.fragment = null;
    }

    if (this.authService.isLoggedIn()) {
      return true;
    }

    if (state.url ){
      try {
        sessionStorage.setItem('deepLink', state.url);
      } catch(e) {
         //Error expecting while setting the session storage in browser's incognito mode
      }
    }



    this.router.navigate(['/']);

    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {

    return this.canActivate(route, state);
  }

}




// WEBPACK FOOTER //
// ./src/app/auth/auth-guard.service.ts